module.exports = __webpack_public_path__ + "static/media/backmusic2.f243d79e.mp3";